import { render } from "./DismissingAlerts.vue?vue&type=template&id=29cc9588&ts=true"
import script from "./DismissingAlerts.vue?vue&type=script&lang=ts"
export * from "./DismissingAlerts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__